import React, { useCallback, useState } from "react";
import SearchImage from "../images/Search.png";
import DetailsCardItem from "./DetailsCardItem";

const DetailsCard = ({
  title,
  dataArray,
  loading = false,
  error = false,
  errorMessage = "",
  editable = false,
  editableFields = [],
  onEdit,
  onEditingStateChange,
}) => {
  const [editingFieldsCount, setEditingFieldsCount] = useState(0);

  const handleFieldEdit = useCallback(
    (label, value, subValue) => {
      if (onEdit) {
        onEdit(label, value, subValue);
      }
    },
    [onEdit]
  );

  const handleFieldEditingStateChange = useCallback(
    (isEditing) => {
      setEditingFieldsCount((prev) => {
        const newCount = isEditing ? prev + 1 : Math.max(0, prev - 1);
        if (onEditingStateChange) {
          onEditingStateChange(newCount > 0);
        }
        return newCount;
      });
    },
    [onEditingStateChange]
  );

  if (loading) {
    return (
      <div className="card-section" style={{ flex: 1 }}>
        <h3 className="card-section__title">{title}</h3>
        <div className="details-item-container">
          {[...Array(6)].map((_, index) => (
            <div className="icon-details-item" key={index}>
              <div className="skeleton skeleton-icon"></div>
              <div className="icon-details-text">
                <div className="skeleton skeleton-text skeleton-text--small"></div>
                <div className="skeleton skeleton-text skeleton-text--medium"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card-section" style={{ flex: 1 }}>
        <h3 className="card-section__title">{title}</h3>
        <div className="error-state">
          <img src={SearchImage} alt="Error" className="error-image" />
          <h4 className="error-title">Error Fetching Data</h4>
          <p className="error-message">{errorMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="card-section"
      style={{
        flex: 1,
      }}
    >
      <div className="card-section-header">
        <h3 className="card-section__title">{title}</h3>
      </div>

      <div className="details-item-container">
        {dataArray.map((item, index) => (
          <DetailsCardItem
            key={index}
            index={index}
            label={item.label}
            value={item.value}
            icon={item.icon}
            avatar={item.avatar}
            subValue={item.subValue}
            extraInfo={item.extraInfo}
            copyable={item.copyable}
            editable={editable}
            editableFields={editableFields}
            onEdit={handleFieldEdit}
            onEditingStateChange={handleFieldEditingStateChange}
          />
        ))}
      </div>
    </div>
  );
};

export default DetailsCard;
